// Generated by scripts/sync-bindings.ts (bindings.config.ts joined with specs/openapi.json). Do not edit.

/** The component that renders one MCP tool result. `toolName` is the key it is found under. */
export interface ToolComponentEntry {
  /** Custom-element tag to create, query, or render. */
  tag: string;
  /** Export name in the React and Vue packages. */
  pascal: string;
  /** OpenAPI operation the tool calls. */
  operationId: string;
  /** Config attributes that select this endpoint on a component that renders several. Set them beside `data`. */
  attrs?: Record<string, string>;
}

/** MCP tool name -> the component that draws its result. */
export const TOOL_COMPONENTS: Record<string, ToolComponentEntry> = {
  "post_astrology_natal_chart": {
    "tag": "roxy-natal-chart",
    "pascal": "RoxyNatalChart",
    "operationId": "generateNatalChart"
  },
  "post_astrology_synastry": {
    "tag": "roxy-synastry-chart",
    "pascal": "RoxySynastryChart",
    "operationId": "calculateSynastry"
  },
  "post_astrology_transits": {
    "tag": "roxy-transits-table",
    "pascal": "RoxyTransitsTable",
    "operationId": "calculateTransits"
  },
  "post_astrology_transit_aspects": {
    "tag": "roxy-transit-wheel",
    "pascal": "RoxyTransitWheel",
    "operationId": "calculateTransitAspects"
  },
  "post_astrology_aspects": {
    "tag": "roxy-aspects-table",
    "pascal": "RoxyAspectsTable",
    "operationId": "calculateAspects"
  },
  "post_astrology_aspect_patterns": {
    "tag": "roxy-aspects-table",
    "pascal": "RoxyAspectsTable",
    "operationId": "detectAspectPatterns"
  },
  "get_astrology_moon_phase_current": {
    "tag": "roxy-moon-phase",
    "pascal": "RoxyMoonPhase",
    "operationId": "getCurrentMoonPhase",
    "attrs": {
      "mode": "current"
    }
  },
  "get_astrology_moon_phase_upcoming": {
    "tag": "roxy-moon-phase",
    "pascal": "RoxyMoonPhase",
    "operationId": "getUpcomingMoonPhases",
    "attrs": {
      "mode": "upcoming"
    }
  },
  "get_astrology_moon_phase_calendar_year_month": {
    "tag": "roxy-moon-phase",
    "pascal": "RoxyMoonPhase",
    "operationId": "getMoonCalendar",
    "attrs": {
      "mode": "calendar"
    }
  },
  "get_astrology_horoscope_sign_daily": {
    "tag": "roxy-horoscope-card",
    "pascal": "RoxyHoroscopeCard",
    "operationId": "getDailyHoroscope",
    "attrs": {
      "period": "daily"
    }
  },
  "get_astrology_horoscope_sign_weekly": {
    "tag": "roxy-horoscope-card",
    "pascal": "RoxyHoroscopeCard",
    "operationId": "getWeeklyHoroscope",
    "attrs": {
      "period": "weekly"
    }
  },
  "get_astrology_horoscope_sign_monthly": {
    "tag": "roxy-horoscope-card",
    "pascal": "RoxyHoroscopeCard",
    "operationId": "getMonthlyHoroscope",
    "attrs": {
      "period": "monthly"
    }
  },
  "get_astrology_horoscope_sign_yearly": {
    "tag": "roxy-horoscope-card",
    "pascal": "RoxyHoroscopeCard",
    "operationId": "getYearlyHoroscope",
    "attrs": {
      "period": "yearly"
    }
  },
  "post_astrology_astrocartography": {
    "tag": "roxy-astrocartography-map",
    "pascal": "RoxyAstrocartographyMap",
    "operationId": "generateAstrocartography"
  },
  "post_astrology_local_space": {
    "tag": "roxy-local-space-compass",
    "pascal": "RoxyLocalSpaceCompass",
    "operationId": "generateLocalSpace"
  },
  "post_astrology_relocation_chart": {
    "tag": "roxy-relocation-wheel",
    "pascal": "RoxyRelocationWheel",
    "operationId": "generateRelocationChart"
  },
  "post_astrology_asteroids": {
    "tag": "roxy-positions-table",
    "pascal": "RoxyPositionsTable",
    "operationId": "generateAsteroids"
  },
  "post_astrology_lilith": {
    "tag": "roxy-positions-table",
    "pascal": "RoxyPositionsTable",
    "operationId": "generateLilith"
  },
  "post_astrology_progressions": {
    "tag": "roxy-positions-table",
    "pascal": "RoxyPositionsTable",
    "operationId": "generateProgressions"
  },
  "post_astrology_solar_arc": {
    "tag": "roxy-positions-table",
    "pascal": "RoxyPositionsTable",
    "operationId": "generateSolarArc"
  },
  "post_astrology_arabic_lots": {
    "tag": "roxy-positions-table",
    "pascal": "RoxyPositionsTable",
    "operationId": "calculateArabicLots"
  },
  "post_astrology_planets_monthly": {
    "tag": "roxy-ephemeris-table",
    "pascal": "RoxyEphemerisTable",
    "operationId": "getMonthlyTropicalEphemeris"
  },
  "post_vedic_astrology_planetary_positions_monthly": {
    "tag": "roxy-ephemeris-table",
    "pascal": "RoxyEphemerisTable",
    "operationId": "getMonthlyEphemeris"
  },
  "post_astrology_fixed_stars": {
    "tag": "roxy-fixed-stars",
    "pascal": "RoxyFixedStars",
    "operationId": "generateFixedStars"
  },
  "post_astrology_profections": {
    "tag": "roxy-profection-card",
    "pascal": "RoxyProfectionCard",
    "operationId": "generateProfections"
  },
  "post_astrology_compatibility_score": {
    "tag": "roxy-compatibility-card",
    "pascal": "RoxyCompatibilityCard",
    "operationId": "calculateCompatibility",
    "attrs": {
      "mode": "astrology"
    }
  },
  "post_numerology_compatibility": {
    "tag": "roxy-compatibility-card",
    "pascal": "RoxyCompatibilityCard",
    "operationId": "calculateNumCompatibility",
    "attrs": {
      "mode": "numerology"
    }
  },
  "post_biorhythm_compatibility": {
    "tag": "roxy-compatibility-card",
    "pascal": "RoxyCompatibilityCard",
    "operationId": "calculateBioCompatibility",
    "attrs": {
      "mode": "biorhythm"
    }
  },
  "post_vedic_astrology_birth_chart": {
    "tag": "roxy-vedic-kundli",
    "pascal": "RoxyVedicKundli",
    "operationId": "generateBirthChart"
  },
  "post_vedic_astrology_divisional_chart": {
    "tag": "roxy-divisional-chart",
    "pascal": "RoxyDivisionalChart",
    "operationId": "generateDivisionalChart"
  },
  "post_vedic_astrology_navamsa": {
    "tag": "roxy-divisional-chart",
    "pascal": "RoxyDivisionalChart",
    "operationId": "generateNavamsa"
  },
  "post_vedic_astrology_kp_chart": {
    "tag": "roxy-kp-chart",
    "pascal": "RoxyKpChart",
    "operationId": "generateKpChart"
  },
  "post_vedic_astrology_kp_planets": {
    "tag": "roxy-kp-planets-table",
    "pascal": "RoxyKpPlanetsTable",
    "operationId": "getKpPlanets"
  },
  "post_vedic_astrology_kp_ruling_planets": {
    "tag": "roxy-kp-ruling-planets",
    "pascal": "RoxyKpRulingPlanets",
    "operationId": "getKpRulingPlanets"
  },
  "post_vedic_astrology_ashtakavarga": {
    "tag": "roxy-ashtakavarga-grid",
    "pascal": "RoxyAshtakavargaGrid",
    "operationId": "calculateAshtakavarga"
  },
  "post_vedic_astrology_shadbala": {
    "tag": "roxy-shadbala-table",
    "pascal": "RoxyShadbalaTable",
    "operationId": "calculateShadbala"
  },
  "post_vedic_astrology_dasha_major": {
    "tag": "roxy-dasha-timeline",
    "pascal": "RoxyDashaTimeline",
    "operationId": "getMajorDashas",
    "attrs": {
      "period": "major"
    }
  },
  "post_vedic_astrology_dasha_current": {
    "tag": "roxy-dasha-timeline",
    "pascal": "RoxyDashaTimeline",
    "operationId": "getCurrentDasha",
    "attrs": {
      "period": "current"
    }
  },
  "post_vedic_astrology_dasha_sub_mahadasha": {
    "tag": "roxy-dasha-timeline",
    "pascal": "RoxyDashaTimeline",
    "operationId": "getSubDashas",
    "attrs": {
      "period": "sub"
    }
  },
  "post_vedic_astrology_dasha_sub_mahadasha_antardasha": {
    "tag": "roxy-dasha-timeline",
    "pascal": "RoxyDashaTimeline",
    "operationId": "getPratyantardashas",
    "attrs": {
      "period": "antara"
    }
  },
  "post_vedic_astrology_dasha_sub_mahadasha_antardasha_pratyantardasha": {
    "tag": "roxy-dasha-timeline",
    "pascal": "RoxyDashaTimeline",
    "operationId": "getSookshmaDashas",
    "attrs": {
      "period": "sookshma"
    }
  },
  "post_vedic_astrology_dasha_sub_mahadasha_antardasha_pratyantardasha_sookshma": {
    "tag": "roxy-dasha-timeline",
    "pascal": "RoxyDashaTimeline",
    "operationId": "getPranaDashas",
    "attrs": {
      "period": "prana"
    }
  },
  "post_vedic_astrology_compatibility": {
    "tag": "roxy-guna-milan",
    "pascal": "RoxyGunaMilan",
    "operationId": "calculateGunMilan"
  },
  "post_vedic_astrology_panchang_detailed": {
    "tag": "roxy-panchang-table",
    "pascal": "RoxyPanchangTable",
    "operationId": "getDetailedPanchang",
    "attrs": {
      "detail": "detailed"
    }
  },
  "post_vedic_astrology_panchang_basic": {
    "tag": "roxy-panchang-table",
    "pascal": "RoxyPanchangTable",
    "operationId": "getBasicPanchang",
    "attrs": {
      "detail": "basic"
    }
  },
  "post_vedic_astrology_aspects": {
    "tag": "roxy-vedic-aspects",
    "pascal": "RoxyVedicAspects",
    "operationId": "calculateDrishti"
  },
  "post_vedic_astrology_panchang_hora": {
    "tag": "roxy-hora-table",
    "pascal": "RoxyHoraTable",
    "operationId": "getHora"
  },
  "post_vedic_astrology_panchang_choghadiya": {
    "tag": "roxy-choghadiya-grid",
    "pascal": "RoxyChoghadiyaGrid",
    "operationId": "getChoghadiya"
  },
  "post_vedic_astrology_heliacal": {
    "tag": "roxy-heliacal-table",
    "pascal": "RoxyHeliacalTable",
    "operationId": "getHeliacalVisibility"
  },
  "post_vedic_astrology_daily": {
    "tag": "roxy-vedic-daily",
    "pascal": "RoxyVedicDaily",
    "operationId": "getVedicDailyReading"
  },
  "post_vedic_astrology_kp_daily_finance": {
    "tag": "roxy-kp-finance-card",
    "pascal": "RoxyKpFinanceCard",
    "operationId": "getKpDailyFinance"
  },
  "post_vedic_astrology_transit": {
    "tag": "roxy-gochara-table",
    "pascal": "RoxyGocharaTable",
    "operationId": "calculateTransit"
  },
  "post_vedic_astrology_bhava_bala": {
    "tag": "roxy-bhava-bala-table",
    "pascal": "RoxyBhavaBalaTable",
    "operationId": "calculateBhavaBala"
  },
  "post_vedic_astrology_bhav_chalit": {
    "tag": "roxy-bhav-chalit-table",
    "pascal": "RoxyBhavChalitTable",
    "operationId": "calculateBhavChalit"
  },
  "post_vedic_astrology_upagraha": {
    "tag": "roxy-upagraha-table",
    "pascal": "RoxyUpagrahaTable",
    "operationId": "getUpagrahaPositions"
  },
  "post_vedic_astrology_chara_karakas": {
    "tag": "roxy-chara-karakas",
    "pascal": "RoxyCharaKarakas",
    "operationId": "calculateCharaKarakas"
  },
  "post_vedic_astrology_arudha": {
    "tag": "roxy-arudha-padas",
    "pascal": "RoxyArudhaPadas",
    "operationId": "calculateArudhaPadas"
  },
  "get_vedic_astrology_yoga": {
    "tag": "roxy-yoga-list",
    "pascal": "RoxyYogaList",
    "operationId": "listYogas"
  },
  "post_vedic_astrology_yoga_detect": {
    "tag": "roxy-yoga-list",
    "pascal": "RoxyYogaList",
    "operationId": "detectYogas"
  },
  "get_vedic_astrology_yoga_id": {
    "tag": "roxy-yoga-list",
    "pascal": "RoxyYogaList",
    "operationId": "getYoga"
  },
  "get_vedic_astrology_nakshatras_id": {
    "tag": "roxy-nakshatra-card",
    "pascal": "RoxyNakshatraCard",
    "operationId": "getNakshatra"
  },
  "post_vedic_astrology_dosha_manglik": {
    "tag": "roxy-dosha-card",
    "pascal": "RoxyDoshaCard",
    "operationId": "checkManglikDosha",
    "attrs": {
      "type": "manglik"
    }
  },
  "post_vedic_astrology_dosha_kalsarpa": {
    "tag": "roxy-dosha-card",
    "pascal": "RoxyDoshaCard",
    "operationId": "checkKalsarpaDosha",
    "attrs": {
      "type": "kalsarpa"
    }
  },
  "post_vedic_astrology_dosha_sadhesati": {
    "tag": "roxy-dosha-card",
    "pascal": "RoxyDoshaCard",
    "operationId": "checkSadhesati",
    "attrs": {
      "type": "sadhesati"
    }
  },
  "post_numerology_life_path": {
    "tag": "roxy-numerology-card",
    "pascal": "RoxyNumerologyCard",
    "operationId": "calculateLifePath",
    "attrs": {
      "type": "life-path"
    }
  },
  "post_numerology_expression": {
    "tag": "roxy-numerology-card",
    "pascal": "RoxyNumerologyCard",
    "operationId": "calculateExpression",
    "attrs": {
      "type": "expression"
    }
  },
  "post_numerology_soul_urge": {
    "tag": "roxy-numerology-card",
    "pascal": "RoxyNumerologyCard",
    "operationId": "calculateSoulUrge",
    "attrs": {
      "type": "soul-urge"
    }
  },
  "post_numerology_personality": {
    "tag": "roxy-numerology-card",
    "pascal": "RoxyNumerologyCard",
    "operationId": "calculatePersonality",
    "attrs": {
      "type": "personality"
    }
  },
  "post_numerology_birth_day": {
    "tag": "roxy-numerology-card",
    "pascal": "RoxyNumerologyCard",
    "operationId": "calculateBirthDay",
    "attrs": {
      "type": "birth-day"
    }
  },
  "post_numerology_maturity": {
    "tag": "roxy-numerology-card",
    "pascal": "RoxyNumerologyCard",
    "operationId": "calculateMaturity",
    "attrs": {
      "type": "maturity"
    }
  },
  "post_numerology_daily": {
    "tag": "roxy-numerology-card",
    "pascal": "RoxyNumerologyCard",
    "operationId": "getDailyNumber",
    "attrs": {
      "type": "daily"
    }
  },
  "post_numerology_personal_day": {
    "tag": "roxy-numerology-card",
    "pascal": "RoxyNumerologyCard",
    "operationId": "calculatePersonalDay",
    "attrs": {
      "type": "personal-day"
    }
  },
  "post_numerology_personal_month": {
    "tag": "roxy-numerology-card",
    "pascal": "RoxyNumerologyCard",
    "operationId": "calculatePersonalMonth",
    "attrs": {
      "type": "personal-month"
    }
  },
  "post_numerology_personal_year": {
    "tag": "roxy-numerology-card",
    "pascal": "RoxyNumerologyCard",
    "operationId": "calculatePersonalYear",
    "attrs": {
      "type": "personal-year"
    }
  },
  "post_numerology_chart": {
    "tag": "roxy-numerology-card",
    "pascal": "RoxyNumerologyCard",
    "operationId": "generateNumerologyChart",
    "attrs": {
      "type": "chart"
    }
  },
  "post_kabbalah_gematria": {
    "tag": "roxy-gematria",
    "pascal": "RoxyGematria",
    "operationId": "calculateGematria"
  },
  "post_tarot_daily": {
    "tag": "roxy-tarot-card",
    "pascal": "RoxyTarotCard",
    "operationId": "getDailyCard"
  },
  "get_tarot_cards_id": {
    "tag": "roxy-tarot-card",
    "pascal": "RoxyTarotCard",
    "operationId": "getCard"
  },
  "get_tarot_cards": {
    "tag": "roxy-tarot-catalog",
    "pascal": "RoxyTarotCatalog",
    "operationId": "listCards"
  },
  "post_tarot_spreads_three_card": {
    "tag": "roxy-tarot-spread",
    "pascal": "RoxyTarotSpread",
    "operationId": "castThreeCard",
    "attrs": {
      "spread": "three-card"
    }
  },
  "post_tarot_spreads_celtic_cross": {
    "tag": "roxy-tarot-spread",
    "pascal": "RoxyTarotSpread",
    "operationId": "castCelticCross",
    "attrs": {
      "spread": "celtic-cross"
    }
  },
  "post_tarot_spreads_love": {
    "tag": "roxy-tarot-spread",
    "pascal": "RoxyTarotSpread",
    "operationId": "castLoveSpread",
    "attrs": {
      "spread": "love"
    }
  },
  "post_tarot_spreads_career": {
    "tag": "roxy-tarot-spread",
    "pascal": "RoxyTarotSpread",
    "operationId": "castCareerSpread",
    "attrs": {
      "spread": "career"
    }
  },
  "post_tarot_spreads_custom": {
    "tag": "roxy-tarot-spread",
    "pascal": "RoxyTarotSpread",
    "operationId": "castCustomSpread",
    "attrs": {
      "spread": "custom"
    }
  },
  "post_tarot_yes_no": {
    "tag": "roxy-tarot-spread",
    "pascal": "RoxyTarotSpread",
    "operationId": "castYesNo",
    "attrs": {
      "spread": "yes-no"
    }
  },
  "post_tarot_draw": {
    "tag": "roxy-tarot-spread",
    "pascal": "RoxyTarotSpread",
    "operationId": "drawCards",
    "attrs": {
      "spread": "draw"
    }
  },
  "post_human_design_bodygraph": {
    "tag": "roxy-bodygraph",
    "pascal": "RoxyBodygraph",
    "operationId": "generateBodygraph"
  },
  "post_human_design_type": {
    "tag": "roxy-hd-type-card",
    "pascal": "RoxyHdTypeCard",
    "operationId": "calculateType"
  },
  "post_human_design_profile": {
    "tag": "roxy-hd-type-card",
    "pascal": "RoxyHdTypeCard",
    "operationId": "calculateProfile"
  },
  "post_human_design_connection": {
    "tag": "roxy-hd-connection",
    "pascal": "RoxyHdConnection",
    "operationId": "calculateConnection"
  },
  "post_human_design_penta": {
    "tag": "roxy-hd-penta",
    "pascal": "RoxyHdPenta",
    "operationId": "calculatePenta"
  },
  "post_human_design_variables": {
    "tag": "roxy-hd-variables",
    "pascal": "RoxyHdVariables",
    "operationId": "calculateVariables"
  },
  "post_forecast_timeline": {
    "tag": "roxy-forecast-timeline",
    "pascal": "RoxyForecastTimeline",
    "operationId": "generateTimeline"
  },
  "post_forecast_significant_dates": {
    "tag": "roxy-forecast-timeline",
    "pascal": "RoxyForecastTimeline",
    "operationId": "findSignificantDates"
  },
  "post_forecast_transits": {
    "tag": "roxy-forecast-timeline",
    "pascal": "RoxyForecastTimeline",
    "operationId": "forecastTransits"
  },
  "post_forecast_digest": {
    "tag": "roxy-forecast-digest",
    "pascal": "RoxyForecastDigest",
    "operationId": "generateDigest"
  },
  "post_chinese_astrology_bazi_chart": {
    "tag": "roxy-bazi-chart",
    "pascal": "RoxyBaziChart",
    "operationId": "generateBaziChart"
  },
  "post_chinese_astrology_bazi_luck_pillars": {
    "tag": "roxy-luck-pillars",
    "pascal": "RoxyLuckPillars",
    "operationId": "calculateLuckPillars"
  },
  "post_chinese_astrology_zodiac_sign": {
    "tag": "roxy-zodiac-card",
    "pascal": "RoxyZodiacCard",
    "operationId": "calculateZodiacAnimal",
    "attrs": {
      "mode": "sign"
    }
  },
  "get_chinese_astrology_zodiac_animals_id": {
    "tag": "roxy-zodiac-card",
    "pascal": "RoxyZodiacCard",
    "operationId": "getZodiacAnimal",
    "attrs": {
      "mode": "animal"
    }
  },
  "get_chinese_astrology_zodiac_id_daily": {
    "tag": "roxy-zodiac-card",
    "pascal": "RoxyZodiacCard",
    "operationId": "getDailyZodiacReading",
    "attrs": {
      "mode": "daily"
    }
  },
  "get_chinese_astrology_zodiac_compatibility_sign1_sign2": {
    "tag": "roxy-zodiac-card",
    "pascal": "RoxyZodiacCard",
    "operationId": "getZodiacCompatibility",
    "attrs": {
      "mode": "compatibility"
    }
  },
  "get_chinese_astrology_calendar_day_date": {
    "tag": "roxy-almanac-day",
    "pascal": "RoxyAlmanacDay",
    "operationId": "getAlmanacDay",
    "attrs": {
      "mode": "day"
    }
  },
  "get_chinese_astrology_calendar_monthly": {
    "tag": "roxy-almanac-day",
    "pascal": "RoxyAlmanacDay",
    "operationId": "getMonthlyAlmanac",
    "attrs": {
      "mode": "month"
    }
  },
  "post_chinese_astrology_calendar_auspicious_days": {
    "tag": "roxy-almanac-day",
    "pascal": "RoxyAlmanacDay",
    "operationId": "lookupAuspiciousDays",
    "attrs": {
      "mode": "auspicious"
    }
  },
  "post_feng_shui_flying_stars_natal": {
    "tag": "roxy-flying-star-chart",
    "pascal": "RoxyFlyingStarChart",
    "operationId": "generateFlyingStarChart",
    "attrs": {
      "mode": "natal"
    }
  },
  "get_feng_shui_flying_stars_annual_year": {
    "tag": "roxy-flying-star-chart",
    "pascal": "RoxyFlyingStarChart",
    "operationId": "getAnnualFlyingStars",
    "attrs": {
      "mode": "annual"
    }
  },
  "post_feng_shui_kua": {
    "tag": "roxy-kua-card",
    "pascal": "RoxyKuaCard",
    "operationId": "calculateKuaNumber",
    "attrs": {
      "mode": "kua"
    }
  },
  "post_feng_shui_eight_mansions": {
    "tag": "roxy-kua-card",
    "pascal": "RoxyKuaCard",
    "operationId": "generateEightMansions",
    "attrs": {
      "mode": "mansions"
    }
  },
  "post_mesoamerican_astrology_mayan_tzolkin": {
    "tag": "roxy-mayan-day-sign",
    "pascal": "RoxyMayanDaySign",
    "operationId": "calculateTzolkin",
    "attrs": {
      "mode": "day"
    }
  },
  "post_mesoamerican_astrology_mayan_chart": {
    "tag": "roxy-mayan-day-sign",
    "pascal": "RoxyMayanDaySign",
    "operationId": "generateMayanChart",
    "attrs": {
      "mode": "chart"
    }
  },
  "post_vastu_mandala": {
    "tag": "roxy-vastu-mandala",
    "pascal": "RoxyVastuMandala",
    "operationId": "generateMandala",
    "attrs": {
      "mode": "mandala"
    }
  },
  "post_vastu_entrance": {
    "tag": "roxy-vastu-mandala",
    "pascal": "RoxyVastuMandala",
    "operationId": "calculateEntrancePada",
    "attrs": {
      "mode": "entrance"
    }
  },
  "post_biorhythm_daily": {
    "tag": "roxy-biorhythm-chart",
    "pascal": "RoxyBiorhythmChart",
    "operationId": "getDailyBiorhythm",
    "attrs": {
      "mode": "daily"
    }
  },
  "post_biorhythm_forecast": {
    "tag": "roxy-biorhythm-chart",
    "pascal": "RoxyBiorhythmChart",
    "operationId": "getForecast",
    "attrs": {
      "mode": "forecast"
    }
  },
  "post_biorhythm_critical_days": {
    "tag": "roxy-biorhythm-chart",
    "pascal": "RoxyBiorhythmChart",
    "operationId": "getCriticalDays",
    "attrs": {
      "mode": "critical-days"
    }
  },
  "post_ayurveda_constitution": {
    "tag": "roxy-dosha-constitution",
    "pascal": "RoxyDoshaConstitution",
    "operationId": "calculateAyurvedicConstitution"
  },
  "get_iching_hexagrams_random": {
    "tag": "roxy-hexagram",
    "pascal": "RoxyHexagram",
    "operationId": "getRandomHexagram"
  },
  "get_iching_hexagrams_number": {
    "tag": "roxy-hexagram",
    "pascal": "RoxyHexagram",
    "operationId": "getHexagram"
  },
  "get_iching_hexagrams_lookup": {
    "tag": "roxy-hexagram",
    "pascal": "RoxyHexagram",
    "operationId": "lookupHexagram"
  },
  "get_iching_cast": {
    "tag": "roxy-hexagram",
    "pascal": "RoxyHexagram",
    "operationId": "castReading"
  },
  "post_iching_daily": {
    "tag": "roxy-hexagram",
    "pascal": "RoxyHexagram",
    "operationId": "getDailyHexagram"
  },
  "post_iching_daily_cast": {
    "tag": "roxy-hexagram",
    "pascal": "RoxyHexagram",
    "operationId": "castDailyReading"
  },
  "get_crystals_id": {
    "tag": "roxy-crystal-card",
    "pascal": "RoxyCrystalCard",
    "operationId": "getCrystal"
  },
  "get_crystals_chakra": {
    "tag": "roxy-crystal-grid",
    "pascal": "RoxyCrystalGrid",
    "operationId": "getCrystalsByChakra"
  },
  "get_crystals_element": {
    "tag": "roxy-crystal-grid",
    "pascal": "RoxyCrystalGrid",
    "operationId": "getCrystalsByElement"
  },
  "get_crystals_zodiac_sign": {
    "tag": "roxy-crystal-grid",
    "pascal": "RoxyCrystalGrid",
    "operationId": "getCrystalsByZodiac"
  },
  "get_crystals": {
    "tag": "roxy-crystal-grid",
    "pascal": "RoxyCrystalGrid",
    "operationId": "listCrystals"
  },
  "get_crystals_birthstone_month": {
    "tag": "roxy-crystal-grid",
    "pascal": "RoxyCrystalGrid",
    "operationId": "getBirthstones"
  },
  "get_crystals_search": {
    "tag": "roxy-crystal-grid",
    "pascal": "RoxyCrystalGrid",
    "operationId": "searchCrystals"
  },
  "get_dreams_symbols_id": {
    "tag": "roxy-dream-card",
    "pascal": "RoxyDreamCard",
    "operationId": "getDreamSymbol"
  },
  "get_dreams_symbols": {
    "tag": "roxy-dream-search",
    "pascal": "RoxyDreamSearch",
    "operationId": "searchDreamSymbols"
  },
  "get_angel_numbers_number": {
    "tag": "roxy-angel-number-card",
    "pascal": "RoxyAngelNumberCard",
    "operationId": "getAngelNumber"
  },
  "get_angel_numbers_lookup": {
    "tag": "roxy-angel-number-lookup",
    "pascal": "RoxyAngelNumberLookup",
    "operationId": "analyzeNumberSequence"
  },
  "get_astrology_signs_id": {
    "tag": "roxy-reference-card",
    "pascal": "RoxyReferenceCard",
    "operationId": "getZodiacSign"
  },
  "get_astrology_planet_meanings_id": {
    "tag": "roxy-reference-card",
    "pascal": "RoxyReferenceCard",
    "operationId": "getPlanetMeaning"
  },
  "get_vedic_astrology_rashis_id": {
    "tag": "roxy-reference-card",
    "pascal": "RoxyReferenceCard",
    "operationId": "getRashi"
  },
  "get_iching_trigrams_id": {
    "tag": "roxy-reference-card",
    "pascal": "RoxyReferenceCard",
    "operationId": "getTrigram"
  },
  "get_human_design_gates_number": {
    "tag": "roxy-reference-card",
    "pascal": "RoxyReferenceCard",
    "operationId": "getGate"
  },
  "get_human_design_centers_id": {
    "tag": "roxy-reference-card",
    "pascal": "RoxyReferenceCard",
    "operationId": "getCenter"
  },
  "get_numerology_meanings_number": {
    "tag": "roxy-reference-card",
    "pascal": "RoxyReferenceCard",
    "operationId": "getNumberMeaning"
  },
  "get_numerology_compound_number": {
    "tag": "roxy-reference-card",
    "pascal": "RoxyReferenceCard",
    "operationId": "getCompoundNumber"
  },
  "get_vedic_astrology_avasthas_id": {
    "tag": "roxy-reference-card",
    "pascal": "RoxyReferenceCard",
    "operationId": "getAvastha"
  }
};
